export const findSingleCode = (data, code) => {
    let singleObject = {}
    const restData = []

    for (const item of data) {
        const hasCode = item.frequencies.some(item => item.code === code)
        if (hasCode) {
            singleObject = item
        }
        else {
            restData.push(item)
        }
    }

    return {
        singleObject,
        restData
    }
}

//Permite obtener los valores del codigo y el id de la frecuencia de cobro si viene ya en la data de lo contrario utiliza valores por defecto
export const getChargeRecurrenceFrequencyCode = ({ defaultValues, newData }) => {
    if (!defaultValues.charge_recurrence_frequency_id ||
        defaultValues.charge_recurrence_frequency_id === newData.singleObject?.frequencies[0]?.charge_recurrence_frequency_id
    ) {
        return {
            charge_recurrence_frequency_code: newData.singleObject?.frequencies[0]?.code,
            charge_recurrence_frequency_id: newData.singleObject?.frequencies[0]?.charge_recurrence_frequency_id,
        }
    }
    return {
        charge_recurrence_frequency_code: newData.restData?.[0].frequencies.find((item) => item.charge_recurrence_frequency_id === defaultValues.charge_recurrence_frequency_id)?.code ?? newData.singleObject?.frequencies[0]?.code,
        charge_recurrence_frequency_id: defaultValues.charge_recurrence_frequency_id ?? newData.singleObject?.frequencies[0]?.charge_recurrence_frequency_id
    }
}